export default {
  data() {
    return {
      email: window?.SB?.user?.email,
    };
  },
  computed: {
    title() {
      if (this.$context.is.buyNow || this.$context.is.basic2pro || this.$context.is.buyTrial) {
        const firstName = window?.SB?.user?.firstName;
        if (firstName && firstName.length <= 18) {
          return this.$t('billing.success.confirmation.thank_you_for_choosing_zoom_with_user_name', [firstName]);
        }
      }
      return '';
    },
  }
}
